import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  SSJBeaconButton,
  SSJBeaconInputField,
  SSJBeaconCheckbox,
  SSJBeaconRadioGroup,
  SSJBeaconRadioButton,
  SSJBeaconIconButton,
  SSJBeaconErrorMessageSummary,
  SSJBeaconError,
} from '../../../Shared/Beacon/Registry';

import './TransferAmount.scss';
import useForm from '../../../Shared/hooks/useForm';
import TransferAmountForm from './TransferAmountForm';
import trashCan from '../../../../assets/images/trashCan.svg';
import dollarSign from '../../../../assets/images/Dollar.svg';
import { incrementStep } from '../../../../redux/modules/transferFunding/stepActions';
import rightArrow from '../../../../assets/images/beacon-chevron-right.svg';
import { putFundingTrackingData } from '../../../../redux/modules/fundingTrackingData/fundingTrackingData.module';
import { beaconPattern } from '../../../../utils/fundingMethod/fundingMethodUtils';
import { dispatchPageLoad } from '../../../../redux/utils/analytics-helper';

const TransferAmount = () => {
  const dispatch = useDispatch();
  const [asset, setAsset] = useState(false);
  const allCashCheckRef = useRef(null);
  const cachCheckBoxRef = useRef(null);
  const addSecurityRef = useRef(null);
  let checkArray = false;
  let checkPattern = false;
  const cdFlag = useSelector(
    (state) =>
      state?.fundingTrackingData?.payload?.onboardingDataStore
        ?.onboardingDatastoreTransfer?.transferCertificateOfDeposit
  );
  useEffect(() => {
    dispatchPageLoad(cdFlag ? 'CD Details' : 'Amount Details');
  }, [cdFlag]);
  const fundingTrackingData = useSelector(
    (state) => state?.fundingTrackingData
  );
  const fundingTrackingDataPayload =
    fundingTrackingData?.payload?.onboardingDataStore
      ?.onboardingDatastoreTransfer;

  const { values, errors, handleSubmit, setValues } = useForm(
    {
      onboardingTransferType:
        fundingTrackingDataPayload?.onboardingTransferType || 'FULL',
      transferCashAsset: fundingTrackingDataPayload?.transferCashAsset || false,
      cashDollarValue: fundingTrackingDataPayload?.cashDollarValue || '',
      transferSecurityAsset:
        fundingTrackingDataPayload?.transferSecurityAsset || false,
      onboardingTransferSecurityDetail:
        fundingTrackingDataPayload?.onboardingTransferSecurityDetail || [],
    },
    () => {
      const cashDollarValue =
        values.cashDollarValue === '' ? 0 : Number(values.cashDollarValue);
      if (fundingTrackingData?.payload?.onboardingDataStore) {
        fundingTrackingData.payload.onboardingDataStore.onboardingDatastoreTransfer =
          {
            ...fundingTrackingData.payload.onboardingDataStore
              ?.onboardingDatastoreTransfer,
            onboardingTransferType: values.onboardingTransferType,
            transferCashAsset: values.transferCashAsset,
            cashDollarValue: cashDollarValue,
            transferSecurityAsset: values.transferSecurityAsset,
            onboardingTransferSecurityDetail: thickerList,
          };
      }
      if (
        !fundingTrackingData.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer.transferCashAsset &&
        !fundingTrackingData.payload?.onboardingDataStore
          ?.onboardingDatastoreTransfer.transferSecurityAsset &&
        values?.onboardingTransferType !== 'FULL'
      ) {
        setAsset(true);
      } else {
        if (
          values.transferCashAsset &&
          values?.cashDollarValue < 1000 &&
          values?.onboardingTransferType !== 'FULL'
        ) {
          const cashEle = document.querySelector('#cashDollarValue');
          if (cashEle) {
            cashEle?.evaluateValidations();
          }
        } else {
          if (values?.transferSecurityAsset) {
            thickerList?.map((item, index) => {
              if (item?.securityTicker === '') {
                document
                  .querySelector(`#ticker_${index}`)
                  ?.evaluateValidations();
              }
              if (item?.securityQuantity === '') {
                document
                  .querySelector(`#shares_${index}`)
                  ?.evaluateValidations();
              }
              return <></>;
            });
            checkArray = thickerList.every(
              (item) => !Object.values(item).some((value) => value === '')
            );
            checkPattern = thickerList.every((item1) => {
              if ('securityTicker' in item1) {
                return !item1.securityTicker.startsWith(' ');
              }
              return true;
            });
          }

          if (
            (checkArray && checkPattern) ||
            !values?.transferSecurityAsset ||
            values?.onboardingTransferType === 'FULL'
          ) {
            dispatch(putFundingTrackingData(fundingTrackingData?.payload));
            window.scrollTo(0, 0);
            dispatch(incrementStep());
          }
        }
      }
    }
  );
  // if user passed all his cash funds returns All Cash symbol
  const [cashInputValue, setCashInputValue] = useState(
    fundingTrackingDataPayload?.cashDollarValue || ''
  );
  const [isPartialTransfer, setIsPartialTransfer] = useState(
    fundingTrackingDataPayload?.onboardingTransferType === 'PARTIAL' || false
  );
  // condition checks user passed all his cash funds
  const [thickerList, setThickerList] = useState(
    fundingTrackingDataPayload?.onboardingTransferSecurityDetail || []
  );

  useEffect(() => {
    thickerList.forEach((item, index) => {
      if (item.allShares) {
        const sharesEle = document.querySelector(`#shares_${index}`);
        sharesEle?.evaluateValidations();
      }
    });
  }, [thickerList]);

  /**
   * Event listener enabling disabling inputs.
   */
  /* eslint-disable */
  useEffect(() => {
    if (
      values.transferSecurityAsset &&
      addSecurityRef.current &&
      cachCheckBoxRef.current
    ) {
      const limit = values.transferCashAsset ? 9 : 10;
      addSecurityRef.current.disabled = thickerList.length === limit;
      cachCheckBoxRef.current.disabled = thickerList.length === 10;
    }
  }, [thickerList.length, values.transferCashAsset]);

  const handleTransferInstructions = (e) => {
    const transferType = e.target.value;
    if (transferType === 'PARTIAL') {
      setIsPartialTransfer(true);
    } else if (transferType === 'FULL') {
      setIsPartialTransfer(false);
      setCashInputValue('');
      setThickerList([
        { securityTicker: '', securityQuantity: '', allShares: false },
      ]);
    }
    setValues({
      ...values,
      onboardingTransferType: transferType,
    });
  };

  const handleCheckBoxChange = (e) => {
    e.preventDefault();
    if (
      e.target.name === 'transferCashAsset' &&
      !cachCheckBoxRef.current.disabled
    ) {
      setAsset(false);
      setValues({
        ...values,
        transferCashAsset: !values.transferCashAsset,
      });
    }
    if (e.target.name === 'transferSecurityAsset') {
      setAsset(false);
      setValues({
        ...values,
        transferSecurityAsset: !values.transferSecurityAsset,
      });
      setThickerList([
        { securityTicker: '', securityQuantity: '', allShares: false },
      ]);
    }
    if (e.target.name !== 'transferSecurityAsset') {
      setCashInputValue('');
    }
  };

  const handleCashAssets = (e) => {
    const dollarAmount = e.target.value;
    setCashInputValue(dollarAmount);
    setValues({
      ...values,
      cashDollarValue: dollarAmount,
    });
  };

  const handleCashDelete = () => {
    setCashInputValue('');
    setValues({
      ...values,
      transferCashAsset: false,
    });
  };

  const handleAddThicker = () => {
    // per US AC 10 max including cash or not.
    const limit = values.transferCashAsset ? 8 : 9;
    if (thickerList.length <= limit) {
      setThickerList([
        ...thickerList,
        { securityTicker: '', securityQuantity: '', allShares: false },
      ]);
    }
  };

  /**
   * Updates Ticker name
   *
   * @param {*} e
   * @param {*} index
   */
  const handleTickerChange = (e, index) => {
    thickerList[index].securityTicker = e.target.value;
    setThickerList([...thickerList]);
  };

  /**
   * Updates Share Value for security ticker
   *
   * @param {*} e
   * @param {*} index
   */
  const handleSharesChange = (e, index) => {
    if (Number(e.target.value)) {
      thickerList[index].securityQuantity = e.target.value;
      setThickerList([...thickerList]);
    } else {
      thickerList[index].securityQuantity = '';
      setThickerList([...thickerList]);
    }
  };

  /**
   * Updates Share Value when All Shares checkbox is clicked
   *
   * @param {*} e
   * @param {*} index
   */
  const handleSharesCheckChange = (e, index) => {
    const allSharesStatus = e.target.checked;
    const el = document.getElementById(`shares_${index}`);
    el.disabled = allSharesStatus;
    if (allSharesStatus) {
      thickerList[index].allShares = allSharesStatus;
      thickerList[index].securityQuantity = 'All Shares';
      setThickerList([...thickerList]);
    } else {
      thickerList[index].allShares = allSharesStatus;
      thickerList[index].securityQuantity = '';
      setThickerList([...thickerList]);
    }
  };

  /**
   * Deletes a Security Ticker entry
   *
   * @param {*} index
   */
  const handleDeleteSecurity = (index) => {
    if (thickerList.length > 1) {
      if (thickerList.length === 8) {
        addSecurityRef.current.disabled = false;
      }
      const newArray = [...thickerList];
      newArray.splice(index, 1);
      setThickerList([...newArray]);
    } else {
      setValues({
        ...values,
        transferSecurityAsset: !values.transferSecurityAsset,
      });
    }
  };

  const handleFinalSubmit = () => {
    if (
      values.onboardingTransferType === 'PARTIAL' &&
      !values.transferCashAsset &&
      !values.transferSecurityAsset
    ) {
      setAsset(true);
    }
    if (values.transferSecurityAsset) {
      thickerList.forEach((item, index) => {
        const tickerEle = document.querySelector(`#ticker_${index}`);
        const sharesEle = document.querySelector(`#shares_${index}`);

        tickerEle?.evaluateValidations();
        sharesEle?.evaluateValidations();
      });
    }
    if (values.transferCashAsset) {
      const cashEle = document.querySelector('#cashDollarValue');
      cashEle?.evaluateValidations();
    }
    handleSubmit();
  };

  // CD's Form
  if (cdFlag) {
    return <TransferAmountForm />;
  } else {
    return (
      <div className="transfer-amount">
        <h2 className="transfer-amount_title">Enter your transfer amount </h2>
        <p className="transfer-amount_desc">
          Bring all or some of your existing investments to T. Rowe Price. Most
          transfers are done “in-kind,” which means you can move assets without
          selling shares.
        </p>
        <div>
          {errors.length > 0 && (
            <div className="error-summary">
              <SSJBeaconErrorMessageSummary
                id="error-message-summary"
                errors={errors}
              />
            </div>
          )}
        </div>
        <div className="transfer-amount_details">
          <div className="transfer-amount_details-instruction">
            <SSJBeaconRadioGroup
              id="onboardingTransferType"
              name="onboardingTransferType"
              label="Transfer Instructions"
              hint="You can transfer everything or select specific assets held in your
              account."
              required="true"
              errorsmap='{ "required": "Select Transfer Instructions" }'
            >
              <SSJBeaconRadioButton
                label="Transfer the entire account (most common)"
                value="FULL"
                checked={values.onboardingTransferType === 'FULL'}
                onClick={handleTransferInstructions}
              />
              <SSJBeaconRadioButton
                label="Partial transfer"
                value="PARTIAL"
                checked={values.onboardingTransferType === 'PARTIAL'}
                onClick={handleTransferInstructions}
              />
            </SSJBeaconRadioGroup>
          </div>

          {isPartialTransfer && (
            <div className="transfer-amount_details-partial-transfer">
              <div className="transfer-amount_details-partial-transfer_title">
                Partial Transfer Details{' '}
              </div>
              <p className="transfer-amount_details-partial-transfer_desc">
                Provide details about the outside assets you want to transfer to
                T. Rowe Price. Liquidated assets held in a sweep account will be
                transferred as cash.
              </p>
              <div className="transfer-amount_details-asset-type_title">
                Asset Type(s) to Transfer
              </div>
              <p className="transfer-amount_details-asset-type_desc">
                Select the external assets you’re moving to T. Rowe Price.
              </p>
              {asset && (
                <SSJBeaconError
                  id="checkbox-error"
                  name="checkbox-error"
                  valid="true"
                  message="Select at least one asset type."
                ></SSJBeaconError>
              )}
              <SSJBeaconCheckbox
                label="Cash (liquidated holdings held in a sweep account)"
                checked={values.transferCashAsset}
                id="transferCashAsset"
                className="transfer-amount_details-asset-type-cash"
                name="transferCashAsset"
                value={values.transferCashAsset}
                onClick={handleCheckBoxChange}
                color="primary"
                ref={cachCheckBoxRef}
              />
              <SSJBeaconCheckbox
                label="Securities (individual stocks or bonds)"
                checked={values.transferSecurityAsset}
                id="transferSecurityAsset"
                name="transferSecurityAsset"
                className="transfer-amount_details-asset-type-securities"
                value={values.transferSecurityAsset}
                onClick={handleCheckBoxChange}
                color="primary"
              />
              {values.transferCashAsset && (
                <div className="transfer-amount_partial-cash">
                  <div className="transfer-amount_partial-cash_line">
                    <SSJBeaconInputField
                      id="cashDollarValue"
                      name="cashDollarValue"
                      label="Dollar Value of Cash Assets to Transfer"
                      value={cashInputValue}
                      required="true"
                      icon-position={'left'}
                      icon-url={dollarSign}
                      className="transfer-amount_partial-cash_line_input-field"
                      type="number"
                      maxlength="15"
                      min={1000}
                      format={beaconPattern.sharesRegex}
                      format-type="regexp"
                      errorsMap={{
                        required: 'Cash assets to transfer is required',
                        min: 'Please enter amount of $1000 or above',
                        noMatchPattern: 'Please enter amount of $1000 or above',
                        pattern: 'Please enter amount of $1000 or above',
                      }}
                      onInput={(e) => handleCashAssets(e)}
                      ref={allCashCheckRef}
                    />
                    <div className="transfer-amount_partial-cash_line_row">
                      <SSJBeaconIconButton
                        variant="secondary"
                        label="Delete Button"
                        className="transfer-amount_partial-cash_line_icon"
                        onClick={handleCashDelete}
                      >
                        <img
                          src={trashCan}
                          alt="trash can"
                          slot="icon"
                          width="16"
                          height="16"
                        />
                      </SSJBeaconIconButton>
                    </div>
                  </div>
                </div>
              )}
              {values.transferSecurityAsset && (
                <div className="transfer-amount_partial-security">
                  {thickerList.map((item, index) => {
                    return (
                      <div
                        className="transfer-amount_partial-security_line"
                        key={`ticker_${index}`}
                      >
                        <div className="transfer-amount_partial-security_line_line1">
                          <div className="transfer-amount_partial-security_line_line1_inputs">
                            <SSJBeaconInputField
                              id={`ticker_${index}`}
                              name={`ticker_${index}`}
                              value={item.securityTicker}
                              required="true"
                              label="Ticker/CUSIP Symbol"
                              maxlength="9"
                              pattern={beaconPattern.nameRegex}
                              formatType="regexp"
                              className="transfer-amount_partial-security_line_input-field1"
                              onInput={(e) => handleTickerChange(e, index)}
                              errorsMap={{
                                required: `Ticker symbol is required`,
                              }}
                            />
                            <SSJBeaconInputField
                              id={`shares_${index}`}
                              name={`shares_${index}`}
                              value={item.securityQuantity}
                              disabled={
                                item.allShares ||
                                item.securityQuantity === 'All Shares'
                              }
                              label="Shares to Transfer"
                              className="transfer-amount_partial-security_line_input-field2"
                              onInput={(e) => handleSharesChange(e, index)}
                              formatType="regexp"
                              format={beaconPattern.sharesRegex}
                              required="true"
                              errorsMap={{
                                required: `Shares is required`,
                              }}
                            />
                          </div>
                          <div className="transfer-amount_partial-security_line-shares">
                            <SSJBeaconCheckbox
                              id={`allShares_${index}`}
                              name={`allShares_${index}`}
                              value={
                                item.allShares ||
                                item.securityQuantity === 'All Shares'
                              }
                              checked={
                                item.allShares ||
                                item.securityQuantity === 'All Shares'
                              }
                              label="All Shares"
                              className="transfer-amount_partial-security_line_check"
                              onClick={(e) => handleSharesCheckChange(e, index)}
                            />
                            <SSJBeaconIconButton
                              variant="secondary"
                              label="Delete Button"
                              className="transfer-amount_partial-security_line_icon"
                              onClick={() => handleDeleteSecurity(index)}
                            >
                              <img
                                src={trashCan}
                                alt="trash can"
                                slot="icon"
                                width="16"
                                height="16"
                              />
                            </SSJBeaconIconButton>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <SSJBeaconButton
                    variant="tertiary"
                    label="+ Add Another Security"
                    className="transfer-amount_partial-security_btn"
                    onClick={handleAddThicker}
                    ref={addSecurityRef}
                  />
                </div>
              )}
            </div>
          )}

          <SSJBeaconButton
            variant="primary"
            label="Continue"
            id="continueButton"
            scale="jumbo"
            className="transfer-account-details_continue-btn transfer-amount_continue-btn"
            onClick={handleFinalSubmit}
          >
            <img
              slot="icon"
              icon-align="right"
              alt="Continue Button"
              className="continue-arrow-icon"
              fill="none"
              height="16"
              width="16"
              src={rightArrow}
            />
          </SSJBeaconButton>
        </div>
      </div>
    );
  }
};

export default TransferAmount;
